import { ArrowDown } from "lucide-react";
import React, { useEffect, useState } from "react";

const TimePicker = ({startTime, setStartTime, endTime, setEndTime}) => {
  
  const handleChange = (setTime, field, value) => {
    setTime((prev) => ({ ...prev, [field]: value }));
  };

  const togglePeriod = (setTime) => {
    setTime((prev) => ({
      ...prev,
      period: prev.period === "AM" ? "PM" : "AM",
    }));
  };



  return (
    <div className="time-picker-container mt-3">
      <div className="time-input-group">
        <input
          type="number"
          value={startTime.hours}
          onChange={(e) =>
            handleChange(
              setStartTime,
              "hours",
              Math.min(12, Math.max(1, Number(e.target.value)))
            )
          }
          className="time-input"
        />
        <span className="colon">:</span>
        <input
          type="number"
          value={startTime.minutes}
          onChange={(e) =>
            handleChange(
              setStartTime,
              "minutes",
              Math.min(59, Math.max(0, Number(e.target.value)))
            )
          }
          className="time-input"
        />
        <div
          className="am-pm-toggle"
          onClick={() => togglePeriod(setStartTime)}
        >
          <div className={startTime.period === "AM" ? "selected" : ""}>AM</div>
          <div className={startTime.period === "PM" ? "selected" : ""}>PM</div>
        </div>
      </div>
      <ArrowDown className="arrow text_gray" width={16} height={16} />
      <div className="time-input-group">
        <input
          type="number"
          value={endTime.hours}
          onChange={(e) =>
            handleChange(
              setEndTime,
              "hours",
              Math.min(12, Math.max(1, Number(e.target.value)))
            )
          }
          className="time-input"
        />
        <span className="colon">:</span>
        <input
          type="number"
          value={endTime.minutes}
          onChange={(e) =>
            handleChange(
              setEndTime,
              "minutes",
              Math.min(59, Math.max(0, Number(e.target.value)))
            )
          }
          className="time-input"
        />
        <div className="am-pm-toggle" onClick={() => togglePeriod(setEndTime)}>
          <div className={endTime.period === "AM" ? "selected" : ""}>AM</div>
          <div className={endTime.period === "PM" ? "selected" : ""}>PM</div>
        </div>
      </div>
      {/* <div className="stored-time">
        Stored Start Time: {convertTo24HourFormat(startTime)}
      </div>
      <div className="stored-time">
        Stored End Time: {convertTo24HourFormat(endTime)}
      </div> */}
    </div>
  );
};

export default TimePicker;
